import useLogisticParties from './useLogisticParties';

export function useSelectedLp() {
  const logisticParties = useLogisticParties();
  return logisticParties?.lpSelected;
}

export default useSelectedLp;
